export const LEGAL_DOCUMENTS_TYPES = {
    GENERAL_TERMS_AND_CONDITIONS_OF_USE: 'GTACU',
    GENERAL_DATA_PROTECTION_REGULATION: 'GDPR',
    SPECIAL_TERMS: 'ST',
} as const;

export type LegalDocumentType = (typeof LEGAL_DOCUMENTS_TYPES)[keyof typeof LEGAL_DOCUMENTS_TYPES];
